<template>
	<el-dialog :title="dialogType=='add'?'新增用户':'编辑用户'" :visible.sync="outerVisible" :before-close="beforeClose">
		<el-form :model="teacherModel" :rules="rules" ref="teacherModel" label-width="100px">
			<el-form-item label="学校" prop="schoolID">
				<el-select v-model="teacherModel.schoolID" placeholder="请选择学校">
					<el-option v-for="item in getSchoolArray" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="姓名" prop='name'>
				<el-input v-model="teacherModel.name"></el-input>
			</el-form-item>
			<el-form-item label="账号" prop="loginID">
				<el-input v-model="teacherModel.loginID"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="loginPwd">
				<el-input v-model="teacherModel.loginPwd" type="password"></el-input>
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input v-model="teacherModel.phone"></el-input>
			</el-form-item>
			<el-form-item label="截止">
				<el-date-picker v-model="teacherModel.stopTime" type="datetime" placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="save">确定</el-button>
			<el-button @click="resetForm">重置</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				teacherModel: {
					name: '',
					loginID: '',
					loginPwd: '',
					schoolID: '',
					stopTime: ''
				},
				schoolList: [],
				rules: {
					name: [{
						required: true,
						message: '请输入用户名称',
						trigger: 'blur'
					}],
					loginID: [{
						required: true,
						message: '请输入登录账号',
						trigger: 'blur'
					}],
					loginPwd: [{
						required: true,
						message: '请输入登录密码',
						trigger: 'blur'
					}],
					schoolID: [{
						required: true,
						message: '请选择学校',
						trigger: ["blur", 'change']
					}]
				}
			}
		},
		props: {
			dialogType: {
				type: String,
				default: 'add'
			},
			outerVisible: {
				type: Boolean,
				default: false
			},
			objdata: {
				type: Object
			},
			roleID: {
				type: Number,
				default: 5
			},
			getSchoolArray: {
				type: Array
			}
		},
		watch: {
			//检测属性的值是否从发生改变
			objdata(val) {
				this.teacherModel = JSON.parse(JSON.stringify(val))
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		methods: {
			resetForm() {
				this.$refs['teacherModel'].resetFields();
			},
			save() {
				if (typeof(this.teacherModel.stopTime) != "string") {
					this.teacherModel.stopTime = this.$time.timeStamp_dateFormater('YYYY-MM-DD HH:mm', this.teacherModel.stopTime.getTime())
				}
				this.teacherModel.roleID = this.roleID
				this.teacherModel.origin = 'off_UserManage'

				if (this.teacherModel.phone && !/^1[3456789]\d{9}$/.test(this.teacherModel.phone)) {
					this.$message({
						message: '手机号格式不正确:' + this.teacherModel.phone,
						type: 'danger'
					})
				} else {
					if (this.dialogType == 'add') {
						this.$http.post('api/User/RegisterUsers', this.teacherModel)
							.then(res => {
								if (res.data.code == "1") {
									this.$message({
										message: "用户添加成功",
										type: 'success'
									})
									this.beforeClose(true)
								} else {
									this.$message({
										message: res.data.message,
										type: 'danger'
									})
								}
							})
							.catch(ex => {
								this.$message({
									message: ex.body,
									type: 'danger'
								})
							})
					} else {
						this.$http.post('api/User/EditUser', this.teacherModel)
							.then(res => {
								if (res.data.code == "1") {
									this.$message({
										message: "用户编辑成功",
										type: 'success'
									})
									this.beforeClose(true)
								} else {
									this.$message({
										message: res.data.message,
										type: 'danger'
									})
								}
							})
							.catch(ex => {
								this.$message({
									message: ex.body,
									type: 'danger'
								})
							})
					}
				}
			},
			//调用此方法，主页面触发事件
			beforeClose(val) {
				this.$emit('before-close', val)
			}
		}
	}
</script>

<style>
</style>
